/* ON-H · carrello laterale col cavallo (20 ott 2026). Sostituisce assets/cart-drawer.js di Dawn e il cassetto dell'app AOV.
   Sorgente: mappa_cavallo/scheda/carrello_src.js → copiato da carrello.py. Markup: snippets/cart-drawer.liquid (generato).
   - stessi metodi del cassetto Dawn (open, close, renderContents, getSectionsToRender, setActiveElement): il modulo prodotto,
     l'aggiunta rapida e la pagina carrello del tema funzionano come prima
   - quantità, togli, consigli della routine e «aggiungi tutti e due» con /cart/*.js + sezioni ridisegnate dal tema
   - il cavallo (disegno di onh-mappa.js) resta lo stesso nodo tra un aggiornamento e l'altro: si accendono solo le zone nuove
   - le aggiunte fatte da altri script (blocchi «spesso insieme», Consulente, mappa) aggiornano e aprono il carrello */
(() => {
  if (customElements.get('cart-drawer')) return;

  const SEZIONI = 'cart-drawer,cart-icon-bubble';
  const ridotto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rotte = () => window.routes || {cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart'};
  const json = (url, body) => fetch(url, {
    method: 'POST',
    headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Onh': '1'},
    body: JSON.stringify(body)
  }).then(r => r.json().then(d => { if (!r.ok || d.status) { const e = new Error(d.description || d.message || 'carrello'); e.dati = d; throw e; } return d; }));
  const dentroSezione = (html, sel) => { const d = new DOMParser().parseFromString(html, 'text/html'); return d.querySelector(sel); };

  /* ---------- il disegno del cavallo arriva da onh-mappa.js (già caricato nelle schede cavallo e in home) ---------- */
  let caricamento = null;
  function caricaCavallo(src) {
    if (window.ONH_MAPPA_API) return Promise.resolve(window.ONH_MAPPA_API);
    if (!src) return Promise.reject(new Error('cavallo'));
    if (!caricamento) caricamento = new Promise((ok, no) => {
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = () => window.ONH_MAPPA_API ? ok(window.ONH_MAPPA_API) : no(new Error('cavallo'));
      s.onerror = () => { caricamento = null; no(new Error('cavallo')); };
      document.head.appendChild(s);
    });
    return caricamento;
  }

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.coda = Promise.resolve();
      this.vecchio = false;
      this.addEventListener('keyup', e => { if (e.code === 'Escape') this.close(); });
      this.addEventListener('click', e => this.clic(e));
      this.addEventListener('input', e => this.scrive(e));
      this.setHeaderCartIconAccessibility();
      this.trascina();
    }

    connectedCallback() {
      if (this.pronto) return;
      this.pronto = true;
      this.aggiornato = Date.now();
      /* aggiornamenti del carrello fatti dal tema (pagina carrello) o da altri script */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, ev => {
          if (!ev || ev.source === 'onh-carrello' || ev.source === 'product-form') return;
          this.segnaVecchio();
        });
      }
      document.addEventListener('onh:carrello-esterno', e => this.esterno(e.detail || {}));
      document.addEventListener('cart:refresh', () => this.esterno({tipo: 'add'}));
      addEventListener('pageshow', e => { if (e.persisted) { this.vecchio = true; this.ricarica({silenzioso: true}); } });
      /* ogni link al carrello apre il cassetto */
      document.addEventListener('click', e => {
        const a = e.target.closest && e.target.closest('a[href]');
        if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || this.contains(a)) return;
        let u;
        try { u = new URL(a.href, location.href); } catch (err) { return; }
        if (u.origin !== location.origin || !/\/cart\/?$/.test(u.pathname) || u.search) return;
        e.preventDefault();
        const d = a.closest('dialog[open]');
        if (d) d.close();
        this.ricarica({apri: true});
      });
      /* chi chiamava il cassetto AOV (es. il Consulente) apre questo */
      if (!window.aovCartDrawerUpdateAndOpen) {
        window.aovCartDrawerUpdateAndOpen = () => this.ricarica({apri: true});
        window.aovCartDrawerOpen = () => this.open();
      }
      /* il disegno del cavallo si prepara quando la pagina è ferma, così la prima apertura è immediata */
      const prepara = () => caricaCavallo(this.pannello() && this.pannello().dataset.cavJs).catch(() => {});
      if ('requestIdleCallback' in window) requestIdleCallback(prepara, {timeout: 4000}); else setTimeout(prepara, 2500);
    }

    pannello() { return this.querySelector('.onh-cd__pann'); }

    /* ---------- metodi del cassetto Dawn ---------- */
    setHeaderCartIconAccessibility() {
      const link = document.querySelector('#cart-icon-bubble');
      if (!link || link.dataset.onhCd) return;
      link.dataset.onhCd = '1';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', e => { e.preventDefault(); this.open(link); });
      link.addEventListener('keydown', e => { if (e.code.toUpperCase() === 'SPACE') { e.preventDefault(); this.open(link); } });
    }
    setActiveElement(el) { this.activeElement = el; }
    getSectionsToRender() { return [{id: 'cart-drawer', selector: '#CartDrawer'}, {id: 'cart-icon-bubble'}]; }
    getSectionInnerHTML(html, selector = '.shopify-section') { const n = dentroSezione(html, selector); return n ? n.innerHTML : ''; }
    getSectionDOM(html, selector = '.shopify-section') { return dentroSezione(html, selector); }

    open(da) {
      if (da) this.setActiveElement(da);
      /* il carrello può essere cambiato in un'altra scheda: se il disegno ha più di 30 secondi si riprende fresco */
      if (this.vecchio || Date.now() - (this.aggiornato || 0) > 30000) this.ricarica({silenzioso: true});
      if (this.classList.contains('active')) { this.cavallo(); return; }
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('onh-cd-aperto');
      const p = this.pannello();
      const fuoco = () => { try { trapFocus(this.querySelector('#CartDrawer'), p); } catch (e) { p && p.focus({preventScroll: true}); } };
      if (ridotto) fuoco(); else p.addEventListener('transitionend', fuoco, {once: true});
      setTimeout(fuoco, 450);
      this.cavallo();
      this.foto();
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('onh_carrello_aperto', {}); } catch (e) {}
    }
    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('onh-cd-aperto');
      try { removeTrapFocus(this.activeElement); } catch (e) {}
    }

    /* dopo «Aggiungi al carrello» del modulo prodotto (risposta di /cart/add con le sezioni) */
    renderContents(stato) {
      const nuovi = stato.key ? [stato.key] : (stato.items || []).map(i => i.key);
      if (stato.sections) this.applica(stato.sections, {nuovi});
      else this.ricarica({nuovi});
      setTimeout(() => this.open());
    }

    /* ---------- aggiornamento: il cavallo e la nota restano gli stessi nodi ---------- */
    applica(sezioni, opt = {}) {
      const bolla = sezioni['cart-icon-bubble'], ic = document.getElementById('cart-icon-bubble');
      if (bolla && ic) { const n = dentroSezione(bolla, '.shopify-section'); if (n) ic.innerHTML = n.innerHTML; }
      const html = sezioni['cart-drawer'];
      if (!html) return;
      const nuovo = dentroSezione(html, '#CartDrawer');
      const wrap = this.querySelector('#CartDrawer');
      if (!nuovo || !wrap) return;
      const corpo = this.querySelector('[data-onh-corpo]'), alto = corpo ? corpo.scrollTop : 0;
      const chiave = b => (b.dataset.vuoto ? 'vuoto' : b.dataset.animale || 'cavallo');
      this.querySelectorAll('[data-onh-cd-cav]').forEach(vb => {
        const s = vb.querySelector('.onh-cd__cav-scena');
        if (!s || !s._sc) return;
        const nb = [...nuovo.querySelectorAll('[data-onh-cd-cav]')].find(b => chiave(b) === chiave(vb));
        if (nb) nb.querySelector('.onh-cd__cav-scena').replaceWith(s);
      });
      const nVecchia = this.querySelector('.onh-cd__nota'), nNuova = nuovo.querySelector('.onh-cd__nota');
      if (nVecchia && nNuova && nVecchia.contains(document.activeElement)) nNuova.replaceWith(nVecchia);
      wrap.replaceChildren(...nuovo.childNodes);
      this.classList.toggle('is-empty', !!this.querySelector('.onh-cd__vuoto'));
      const c2 = this.querySelector('[data-onh-corpo]');
      if (c2) c2.scrollTop = alto;
      (opt.nuovi || []).forEach(k => {
        const r = this.querySelector(`.onh-cd__riga[data-key="${CSS.escape(k)}"]`);
        if (!r) return;
        r.classList.add('appena');
        const b = document.createElement('span');
        b.className = 'onh-cd__appena';
        b.textContent = this.pannello().dataset.tAggiunto || '✓';
        r.querySelector('.onh-cd__info').prepend(b);
      });
      this.vecchio = false;
      this.aggiornato = Date.now();
      if (this.classList.contains('active')) { this.cavallo(); this.foto(); }
      document.dispatchEvent(new CustomEvent('onh:carrello'));
    }

    /* le foto aspettano l'apertura (chi non apre il carrello non le scarica), poi arrivano subito */
    foto() { this.querySelectorAll('img[loading="lazy"]').forEach(i => { i.loading = 'eager'; }); }

    cavallo() {
      const blocchi = [...this.querySelectorAll('[data-onh-cd-cav]')];
      if (!blocchi.length) return;
      caricaCavallo(this.pannello().dataset.cavJs).then(API => blocchi.forEach(b => this.disegna(API, b)))
        .catch(() => blocchi.forEach(b => b.classList.add('senza-cavallo')));
    }
    disegna(API, blocco) {
      const host = blocco.querySelector('.onh-cd__cav-scena');
      if (!host || !host.isConnected) return;
      const vuoto = blocco.dataset.vuoto === '1', an = vuoto ? 'cavallo' : (blocco.dataset.animale || 'cavallo');
      if (!host._sc) {
        host._sc = API.scena(host, {pref: 'onhcd' + Math.random().toString(36).slice(2, 6), animale: an, vb: API.vb(vuoto ? .06 : .03, an), r2: vuoto ? .026 : .042, tocco: true, scan: !vuoto,
          tocca: id => this.toccaZona(id), sopra: id => this.evidenzia(id)});
        host._zone = new Set();
        host._prop = '';
      }
      const sc = host._sc;
      if (vuoto) {
        if (!host._acceso) { host._acceso = true; API.zone(an).forEach((z, i) => sc.accendiZona(z, ridotto ? 0 : 200 + i * 260)); }
        return;
      }
      const zone = (blocco.dataset.zone || '').split(',').filter(Boolean);
      /* le proposte sono di tutto il carrello (i numeri seguono le schede): su questo disegno solo quelle del suo animale */
      const tutte = (blocco.dataset.proposte || '').split(',').filter(Boolean);
      const mie = tutte.map((z, i) => ({z, n: i + 1})).filter(x => API.animaleDi(x.z) === an && x.z !== 'cavaliere');
      const prop = mie.map(x => x.z);
      const vecchie = host._zone;
      let n = 0;
      API.zone(an).forEach(z => {
        if (zone.includes(z)) sc.accendiZona(z, vecchie.has(z) || ridotto ? 0 : 150 + 320 * n++, false);
        else if (prop.includes(z)) sc.accendiZona(z, 0, true);
        else sc.spegniZona(z);
      });
      host._zone = new Set(zone);
      /* numeri sulle zone proposte, come le schede qui sotto */
      const firma = mie.map(x => x.z + x.n).join(',');
      if (host._prop !== firma) {
        host.querySelectorAll('.onh-sc__num').forEach(x => x.remove());
        /* il numero sta appena sopra la zona, come una puntina, così non copre gli esagoni vuoti */
        const posti = API.ancore(mie.map(x => ({zona: x.z}))).map(p => p && [p[0], p[1] - .06]);
        mie.forEach((x, i) => {
          if (!posti[i]) return;
          const b = document.createElement('span');
          b.className = 'onh-sc__num onh-cd__num';
          b.style.setProperty('--zc', API.colore(x.z));
          b.dataset.z = x.z;
          b.innerHTML = `<span>${x.n}</span>`;
          sc.posiziona(b, posti[i]);
        });
        host._prop = firma;
      }
    }

    evidenzia(id) {
      if (matchMedia('(hover: hover)').matches) {
        const ok = id && this.querySelector(`.onh-cd__riga[data-zona="${id}"], .onh-cd__pro[data-zona="${id}"]`) ? id : null;
        this.querySelectorAll('[data-onh-cd-cav] .onh-cd__cav-scena').forEach(s => { if (s._sc) s._sc.evidenzia(ok); });
      }
      this.querySelectorAll('.onh-cd__riga, .onh-cd__pro').forEach(r => r.classList.toggle('attiva', !!id && r.dataset.zona === id));
    }
    toccaZona(id, soloConsigli) {
      const vuoto = this.querySelector('[data-onh-cd-cav][data-vuoto="1"]');
      if (vuoto) { const a = this.querySelector(`[data-onh-zona="${id}"]`); if (a) a.click(); return; }
      const r = this.querySelector(`.onh-cd__pro[data-zona="${id}"]` + (soloConsigli ? '' : `, .onh-cd__riga[data-zona="${id}"]`));
      if (!r) return;
      r.scrollIntoView({block: 'nearest', behavior: ridotto ? 'auto' : 'smooth'});
      r.classList.remove('lampo');
      void r.offsetWidth;
      r.classList.add('lampo');
    }

    /* ---------- azioni ---------- */
    clic(e) {
      const t = e.target;
      if (t.id === 'CartDrawer-Overlay' || t.closest('[data-onh-chiudi]')) { e.preventDefault(); this.close(); return; }
      const q = t.closest('[data-onh-qta]');
      if (q) {
        const riga = q.closest('[data-key]');
        if (!riga) return;
        riga.classList.add('lavora');
        this.azione(rotte().cart_change_url + '.js', {id: riga.dataset.key, quantity: Number(q.dataset.onhQta)}, {bottone: q, volume: q.classList.contains('onh-cd__vol')});
        return;
      }
      const a = t.closest('[data-onh-agg]');
      if (a) { this.aggiungi([Number(a.dataset.onhAgg)], a, 'consiglio'); return; }
      const due = t.closest('[data-onh-due]');
      if (due) { this.aggiungi(due.dataset.onhDue.split(',').filter(Boolean).map(Number), due, 'tutti-e-due'); return; }
      const vai = t.closest('[data-onh-vai]');
      if (vai) { this.toccaZona(vai.dataset.onhVai, true); return; }
      const z = t.closest('[data-onh-zona]');
      if (z && typeof window.ONH_MAPPA_APRI === 'function') { e.preventDefault(); this.close(); window.ONH_MAPPA_APRI(z.dataset.onhZona, 'carrello'); }
    }
    aggiungi(ids, bottone, da) {
      this.azione(rotte().cart_add_url + '.js', {items: ids.map(id => ({id, quantity: 1}))}, {bottone, aggiunta: da, quanti: ids.length});
    }
    azione(url, corpo, opt = {}) {
      const b = opt.bottone;
      if (b) { b.disabled = true; b.classList.add('lavora'); }
      this.pannello().classList.add('occupato');
      this.coda = this.coda.then(() => json(url, Object.assign({}, corpo, {sections: SEZIONI, sections_url: location.pathname}))
        .then(d => {
          const nuovi = opt.aggiunta ? (d.items || [d]).map(i => i.key).filter(Boolean) : [];
          if (d.sections) this.applica(d.sections, {nuovi}); else return this.ricarica({nuovi});
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'onh-carrello', cartData: d});
          if (opt.aggiunta) this.misura(opt.aggiunta, opt.quanti);
          if (opt.volume) this.evento('volume', {});
        })
        .catch(err => {
          /* prima si ridisegna il carrello vero, poi si mostra il messaggio (altrimenti il ridisegno lo cancella) */
          const msg = err && err.dati && (err.dati.description || err.dati.message);
          return this.ricarica({silenzioso: true}).then(() => this.errore(msg));
        })
        .finally(() => {
          this.pannello().classList.remove('occupato');
          if (b && b.isConnected) { b.disabled = false; b.classList.remove('lavora'); }
        }));
      return this.coda;
    }
    ricarica(opt = {}) {
      const r = rotte();
      /* niente «Accept: application/json»: con quello /cart risponde col carrello e ignora le sezioni */
      return fetch(r.cart_url + '?sections=' + SEZIONI + '&t=' + Date.now(), {cache: 'no-store', headers: {'X-Onh': '1'}})
        .then(x => x.json())
        .then(s => { if (!s || !s['cart-drawer']) throw new Error('sezioni'); this.applica(s, opt); if (opt.apri) this.open(); })
        .catch(() => { if (opt.apri) location.href = r.cart_url; });
    }
    segnaVecchio() { if (this.classList.contains('active')) this.ricarica({silenzioso: true}); else this.vecchio = true; }
    esterno(d) {
      /* aggiunte fatte da altri script: si raccolgono per un attimo e poi si ridisegna una volta sola */
      this._est = this._est || {add: false};
      if (d.tipo === 'add') this._est.add = true;
      clearTimeout(this._estT);
      this._estT = setTimeout(() => {
        const add = this._est.add;
        this._est = null;
        const finestraAperta = !!document.querySelector('dialog[open]');
        if (add && !finestraAperta) this.ricarica({apri: true});
        else this.segnaVecchio();
      }, 160);
    }
    errore(msg) {
      const p = this.querySelector('[data-onh-err]');
      if (!p) return;
      p.textContent = msg || this.pannello().dataset.tErr || '';
      p.hidden = false;
      clearTimeout(this._errT);
      this._errT = setTimeout(() => { const q = this.querySelector('[data-onh-err]'); if (q) q.hidden = true; }, 6000);
    }
    scrive(e) {
      if (e.target.name !== 'note') return;
      clearTimeout(this._notaT);
      const testo = e.target.value;
      this._notaT = setTimeout(() => json(rotte().cart_update_url + '.js', {note: testo}).catch(() => {}), 500);
    }

    /* ---------- misura: le aggiunte dal carrello finiscono sull'ordine (attributo nascosto) ---------- */
    misura(da, n) {
      let tot = n;
      try { tot = (Number(sessionStorage.getItem('onh_carrello_aggiunte')) || 0) + n; sessionStorage.setItem('onh_carrello_aggiunte', tot); } catch (e) {}
      json(rotte().cart_update_url + '.js', {attributes: {_onh_carrello_aggiunte: String(tot)}}).catch(() => {});
      this.evento('aggiunta', {da, quanti: n});
    }
    evento(nome, dati) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('onh_carrello_' + nome, dati || {}); } catch (e) {}
    }

    /* sul telefono si chiude anche trascinando il pannello verso destra */
    trascina() {
      let x0 = null, y0 = 0, dx = 0, oriz = null;
      this.addEventListener('touchstart', e => {
        const p = this.pannello();
        if (!p || !p.contains(e.target) || e.target.closest('textarea, .onh-cd__cav-scena')) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; oriz = null;
      }, {passive: true});
      this.addEventListener('touchmove', e => {
        if (x0 == null) return;
        const mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
        if (oriz == null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) oriz = Math.abs(mx) > Math.abs(my) * 1.3;
        if (!oriz) return;
        dx = Math.max(0, mx);
        const p = this.pannello();
        p.style.transition = 'none';
        p.style.transform = `translateX(${dx}px)`;
      }, {passive: true});
      this.addEventListener('touchend', () => {
        if (x0 == null) return;
        const p = this.pannello();
        x0 = null;
        if (!oriz) return;
        p.style.transition = '';
        p.style.transform = '';
        if (dx > 90) this.close();
      });
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  /* ---------- aggiunte e modifiche fatte da altri script con fetch ---------- */
  const fetch0 = window.fetch;
  if (fetch0 && !fetch0._onh) {
    const re = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    const nostro = h => !!h && (typeof h.get === 'function' ? h.get('X-Onh') : (h['X-Onh'] || h['x-onh']));
    const conSezioni = b => (typeof FormData !== 'undefined' && b instanceof FormData && b.has('sections')) || (typeof b === 'string' && /"sections"\s*:/.test(b));
    const avvolto = function (input, init) {
      const p = fetch0.apply(this, arguments);
      try {
        const url = String(typeof input === 'string' || input instanceof URL ? input : (input && input.url) || '');
        const metodo = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        const m = metodo === 'POST' && url.split('#')[0].match(re);
        if (m && !nostro(init && init.headers) && !nostro(input && input.headers) && !conSezioni(init && init.body)) {
          p.then(r => { if (r.ok) document.dispatchEvent(new CustomEvent('onh:carrello-esterno', {detail: {tipo: m[1]}})); }).catch(() => {});
        }
      } catch (e) {}
      return p;
    };
    avvolto._onh = true;
    window.fetch = avvolto;
  }
})();
